<template>
    <div class="info-title">
        {{ $t(data[type].title) }}
    </div>
    <div class="info-content" v-html="data[type].localeContent ? data[type].localeContent : $t(data[type].content)">
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import policy from '@/js/privacy/policy.js'
    export default {
        name: 'AccountInfo',
        data() {
            return {
                policyData: policy,
                data: {
                    about: {
                        title: 'ABOUT_ASPN',
                        content: 'ABOUT_ASPN_CONTENT'
                    },
                    disclaimer: {
                        title: 'DISCLAIMER',
                        content: 'DISCLAIMER_CONTENT'
                    },
                    policy: {
                        title: 'PRIVACY_POLICY',
                        localeContent: '',
                        content: 'PRIVACY_POLICY_CONTENT'
                    }
                }
            }
        },
        props: {
            type: String
        },
        computed: {
            ...mapGetters(['currentLocale'])
        },
        watch: {
            currentLocale(newVal,oldVal) {
                this.init(); 
            }
        },
        mounted() {
        this.init();
        },
        methods: {
            init() {
                if(this.policyData[this.currentLocale]) {
                    this.data.policy.localeContent = this.policyData[this.currentLocale]
                } else {
                    this.data.policy.localeContent = ''
                }
            }
        }
    }
</script>

<style scoped>
.info-title {
    font-size: 32px;
	line-height: 120%;
    color: var(--color-text-default-default);
    margin-bottom: 24px;
	letter-spacing: -0.64px;
    font-family: var(--weight-600);
}
.info-content {
    font-size: 16px;
    color: var(--color-text-default-default);
    margin-bottom: 56px;
	letter-spacing: 0.64px;
}
</style>